var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPaymentIcon = function SvgPaymentIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8E8E93",
    fillRule: "evenodd",
    d: "M20.492 2.493a1 1 0 0 1 1.414 0l9.307 9.307h.786a3.4 3.4 0 0 1 3.4 3.4V19H36.8a1 1 0 0 1 1 1v9.6a1 1 0 0 1-1 1h-1.4v3.8a3.4 3.4 0 0 1-3.4 3.4H5.6a3.4 3.4 0 0 1-3.4-3.4V15.2a3.4 3.4 0 0 1 3.4-3.4h.786l9.307-9.307a1 1 0 0 1 1.414 0l1.692 1.693zm-.997 3.825.012-.01.01-.012L21.2 4.614l7.185 7.186h-14.37zm-2.11-.718-.985-.986L9.215 11.8h1.97zM6.772 13.8H32a1.4 1.4 0 0 1 1.4 1.4V19h-6.2a5.8 5.8 0 0 0 0 11.6h6.197v3.8a1.4 1.4 0 0 1-1.4 1.4H5.6a1.4 1.4 0 0 1-1.4-1.4V15.2a1.4 1.4 0 0 1 1.4-1.4zM34.4 21h-7.2a3.8 3.8 0 0 0 0 7.6h8.6V21h-1.403zM28 27a2 2 0 1 0 0-4 2 2 0 0 0 0 4",
    clipRule: "evenodd"
  })));
};
export default SvgPaymentIcon;